import { useCallback, useState } from 'react'

import {
  Button,
  Dialog,
  Link,
  Text,
  Icon,
  Checkbox,
  Card,
  CardColors,
} from '@/ui'
import { useAppDispatch } from '@/utils/typeHelpers'
import {
  POST_ACCEPT_COMPANY_TOS_KEY,
  postAcceptCompanyTOS,
} from '@/features/payroll/payrollActions'
import { useReselector } from '@/utils/sharedHooks'
import { getIsFetching } from '@/reducers/fetch'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { TypographyStyles } from '@/styles'

export const GustoTosModal = ({
  dismissModal,
}: {
  dismissModal: () => void
}) => {
  const dispatch = useAppDispatch()
  const loading = useReselector(getIsFetching, POST_ACCEPT_COMPANY_TOS_KEY)
  const [checked, setChecked] = useState(false)

  const acceptTos = useCallback(async () => {
    await dispatch(postAcceptCompanyTOS())
    dismissModal()
  }, [dismissModal, dispatch])

  return (
    <Dialog onClose={dismissModal} open>
      <Dialog.Content size="lg">
        <Dialog.Title>Updates to Payroll Terms of Service</Dialog.Title>
        <Dialog.Description>
          <Text variant={TypographyStyles.BODY_SM} className="mt-4">
            Gusto has updated its Payroll Terms of Service. Please review and
            accept the updated terms to continue using Heard Payroll.
          </Text>
          <Link href="https://flows.gusto.com/terms" newPage className="mt-4">
            Read the full Terms of Service{' '}
            <Icon icon={faArrowRight} size="xs" />
          </Link>
          <Card color={CardColors.LEVEL_1}>
            <Checkbox
              label="I have read and accept the updated Terms of Service"
              checked={checked}
              onCheckedChange={setChecked}
            />
          </Card>
        </Dialog.Description>
        <Dialog.Footer>
          <Button
            onClick={acceptTos}
            loading={loading}
            disabled={loading || !checked}
          >
            Accept
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
